import parallaxify from '../vendor/parallax'
import throttle from 'lodash/throttle'

export default {
	template: `
		<div>
			<bg-shifter v-for="(bgShifter, index) in bgShifters"
				:client-coords="clientCoords"
				:screen-center-coords="screenCenterCoords"
				:key="'bg-shifter-' + index"
				:speed="bgShifter.speed"
				:img="bgShifter.img">
			</bg-shifter>
			<slot></slot>
		</div>
	`,

	props: {
		bgShifters: {
			type: Array,
			default: []
		},
		mousemoveEvent: null
	},

	data: () => ({
		clientCoords: {},
		screenCenterCoords: {}
	}),

	watch: {
		mousemoveEvent(event) {
			this.setClientCenterCoords(event)
		}
	},

	methods: {
		setClientCenterCoords(event) {
			this.clientCoords = {
				x: event.clientX,
				y: event.clientY
			}
		},

		setScreenCenterCoords() {
			this.screenCenterCoords = {
				x: Math.floor(window.innerWidth / 2),
				y: Math.floor(window.innerHeight / 2)
			}
		},
	},

	mounted() {
		const parallaxViewport = document.getElementById('parallax-viewport')
		if (parallaxViewport) {
			parallaxify(parallaxViewport)
		}

		this.setScreenCenterCoords()
		const component = this
		window.addEventListener('resize', throttle(component.setScreenCenterCoords, 200))
	},

	components: {
		'bg-shifter': {
			template: `
				<div class="parallax__background parallax__background--layer"
					:style="'background-image: url(' + img + ');'"
					:parallax="speed">
				</div>
			`,

			props: {
				screenCenterCoords: null,
				clientCoords: null,
				img: null,
				speed: null
			},

			watch: {
				clientCoords() {
					if (!this.screenCenterCoords || !this.clientCoords) {
						return
					}
					// Distance from center of screen on axes
					const differenceX = this.screenCenterCoords.x - this.clientCoords.x
					const differenceY = this.screenCenterCoords.y - this.clientCoords.y

					const translateX = differenceX / 1000 * (this.speed * 5) + '%'
					const translateY = differenceY / 1000 * (this.speed * 5) + '%'

					// Note: we can't dynamically bind the transform property here while we are using Google's parallax library, because it sets inline styles on the transform property as well
					// Clean previous translateX and translateY values from inline transform string
					const cleanedTransform = this.$el.style.transform.replace(/( translate)(X|Y)\([-\d.]*%(\))/g, '');

					this.$el.style.transform = `${cleanedTransform} translateX(${translateX}) translateY(${translateY})`
				}
			}
		}
	}
}
